import { EnhancedPlan, PlanSubtypes } from '@mm/state/interfaces/subscription';
import classNames from 'classnames';
import React from 'react';
import { BookDemoButton } from '../../../../../common/buttons/BookDemoButton/BookDemoButton';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { BILLING_PAGE_UTM } from '../../../XRayOnboarding/WebsiteReportSummary/constants';
import styles from './BillingPlans.module.css';
import { BillingPlanCardProps } from './use-billing-plans';

export type Props = {
  option: BillingPlanCardProps;
  getOptionParams: (option: BillingPlanCardProps) => {
    downgrade?: EnhancedPlan;
    currentTag?: boolean;
    buttonNameAdjusted?: string;
  };
  className?: string;
  isAgency?: boolean;
};

export const Plan = ({
  option,
  getOptionParams,
  className,
  isAgency,
}: Props) => {
  const { downgrade, currentTag, buttonNameAdjusted } = getOptionParams(option);
  return (
    <div
      id={option.planCode ? `billing-plan__${option.planCode}` : undefined}
      className={classNames(styles.mainBlock, className, {
        [styles.currentPlanCard]: !!currentTag,
        [styles.customPlan]: option.isCustom,
        [styles.agencyLayout]: isAgency,
      })}
      style={{ backgroundColor: option.cardBgColor }}
    >
      {!currentTag && option.tag && (
        <div
          className={styles.tag}
          style={{ backgroundColor: option.tagBgColor }}
        >
          {option.tag}
        </div>
      )}
      {!isAgency && (
        <span className={styles.startsAt}>
          {option.price ? 'Starts at:' : ''}
        </span>
      )}
      <div
        className={classNames(styles.heading, {
          [styles.agencyHeading]: isAgency,
        })}
      >
        {option.title}

        <div className={classNames(styles.price)}>
          <div className={styles.priceContainer}>
            <span className={styles.priceValue}>
              {' '}
              {option.price}
              <span className={styles.pricePeriod}>{option.pricePeriod}</span>
            </span>
          </div>
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        {option.buttonComponent ? (
          option.buttonComponent(!!currentTag)
        ) : (
          <PrimaryButton
            className={classNames(styles.button, {
              [styles.secondaryButton]: downgrade,
              [styles.disabledButton]: currentTag || option.isFreeTrial,
            })}
            onClick={option.onClick}
            disabled={currentTag || option.isFreeTrial}
          >
            {buttonNameAdjusted}
          </PrimaryButton>
        )}
      </div>
      {option.planSubtypes?.includes(PlanSubtypes.pro2023) && (
        <BookDemoButton
          button="Schedule Demo"
          className={styles.link}
          utm={BILLING_PAGE_UTM('scheduleademo')}
        />
      )}
    </div>
  );
};
